export default "/8522fe2631ecefb1e3967be9883671f05392a386/83e791c702f67cc0242109b04d241be7.svg";